/* Luna Overnight theme script. Ported from design-preview/site.js v6 (Oct 26 2026).
   Same behaviour: pack picker, cart drawer (the Back button closes it), sticky buy bar, mobile menu, gallery,
   email sign-up, first-order pop-up and the tracking hooks. The /cart page (round 2, Oct 27 2026) shows the same lines as the drawer.
   What changed for Shopify: the cart is Shopify's real cart (/cart.js, /cart/add.js, /cart/change.js) and checkout is
   Shopify's checkout; prices, variant ids and the free-delivery rule arrive in window.LO (layout + header section);
   the sign-up forms post to Shopify (a customer with the tag "newsletter"). */
(function(){
'use strict';

function $(s,r){ return (r||document).querySelector(s); }
function $$(s,r){ return [].slice.call((r||document).querySelectorAll(s)); }
function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
var phone = window.matchMedia ? window.matchMedia('(max-width:960px)') : {matches:false};

/* ---- Packs, money and the delivery rule: all numbers come from window.LO (cents) ---- */
var LO = window.LO || {};
var PACKS = LO.packs || {};
var ROUTES = LO.routes || {cartJs:'/cart.js', cartAdd:'/cart/add.js', cartChange:'/cart/change.js', checkout:'/checkout'};
var FREE_OVER = +LO.freeOver || 0;                    // cents; 0 = the Malaysia delivery rule is not set yet, so no free-delivery line shows
var AVATAR = LO.avatar || '';
var THUMB = LO.cartThumb || '';
var CURRENCY = LO.currency || 'MYR';
function money(c){
  var whole = Math.round(c) % 100 === 0;
  return (LO.moneyPrefix || '') + (whole ? String(Math.round(c) / 100) : (c / 100).toFixed(2)) + (LO.moneySuffix || '');
}
function perNight(p){ return money(Math.round(p.price / p.nights)) + ' a night'; }
function avatarImg(w){ return AVATAR ? '<img src="'+esc(AVATAR)+'" alt="" width="'+w+'" height="'+w+'">' : ''; }

/* ---- Tracking hooks ----
   Every cart step reports through track(): add_to_cart, remove_from_cart, view_cart, begin_checkout.
   Names and shape follow GA4 e-commerce, which Google Tag Manager, Meta Pixel and TikTok Pixel can all read.
   An event is pushed onto window.dataLayer and sent as a 'lo:track' event on document. Add ?track to the address to
   also print each event in the browser console. */
window.dataLayer = window.dataLayer || [];
var DEBUG_TRACK = /[?&]track\b/.test(location.search);
function track(name, ecommerce, extra){
  var e = {event:name, ecommerce:ecommerce};
  for(var k in extra) if(Object.prototype.hasOwnProperty.call(extra, k)) e[k] = extra[k];
  try{ window.dataLayer.push({ecommerce:null}); window.dataLayer.push(e); }catch(x){}   // clear first, as GA4 advises
  try{ document.dispatchEvent(new CustomEvent('lo:track', {detail:e})); }catch(x){}
  if(DEBUG_TRACK && window.console) console.log('[track]', e);
}
function trackItem(id, qty){ var p = PACKS[id]; return {item_id:p.sku, item_name:'Night Dream', item_variant:p.label, price:p.price/100, quantity:qty}; }
function trackEcom(items){ var v = 0; items.forEach(function(i){ v += i.price*i.quantity; }); return {currency:CURRENCY, value:v, items:items}; }
function cartItems(){ return cartLines().filter(function(l){ return l.id; }).map(function(l){ return trackItem(l.id, l.qty); }); }
function trackFrom(el){            // which button the shopper used
  if(!el || !el.closest) return 'other';
  return el.closest('#sticky') ? 'sticky_bar' : el.closest('#midbuy') ? 'mid_page' : el.closest('.final-buy') ? 'closing_offer' :
         el.closest('#cart') ? 'cart' : el.closest('#shop') ? 'product_card' : el.closest('#buy') ? 'buy_box' : 'other';
}

/* Stop the page scrolling behind the cart or the pop-up (counted, so the two never fight) */
var locks = 0;
function lock(on){ locks = Math.max(0, locks + (on ? 1 : -1)); document.body.style.overflow = locks ? 'hidden' : ''; }

var cartEl = null, cartOpener = null, cartEntry = false, undoing = false, notice = '';
var popEl = $('#pop');

/* ---- Free-delivery lines: hidden until the header's "Free delivery on orders over" is set ---- */
function applyFree(){
  var on = FREE_OVER > 0;
  $$('[data-free-line]').forEach(function(el){
    el.hidden = !on;
    $$('[data-free-amount]', el).forEach(function(a){ a.textContent = money(FREE_OVER); });
  });
  $$('[data-free-tag]').forEach(function(el){ el.hidden = !(on && +el.getAttribute('data-price') >= FREE_OVER); });
  $$('[data-delivery-tag]').forEach(function(el){ el.hidden = !(on && +el.getAttribute('data-price') < FREE_OVER); });
}

/* ---- Pack picker (product page) ---- */
var singleBagOnly = true;
var sel = 1, pickline = $('#pickline');
var purchaseQty = 1, purchaseInput = $('[data-purchase-qty]');
function syncPurchaseControls(){
  if(!purchaseInput) return;
  purchaseInput.disabled = cartBusy;
  $$('[data-quantity-step]').forEach(function(b){var step=+b.getAttribute('data-quantity-step');b.disabled=cartBusy||(step<0&&purchaseQty<=1)||(step>0&&purchaseQty>=9);});
}
function setPurchaseQty(value){
  if(!purchaseInput || cartBusy) return;
  purchaseQty = Math.max(1,Math.min(9,parseInt(value,10)||1));purchaseInput.value=purchaseQty;
  var p=PACKS[1],go=$('#buy .go');if(go)go.textContent='Add to cart';
  var st=$('#sticky');if(st){
    $('.sticky-current',st).textContent=money(p.price*purchaseQty);
    $('.sticky-pack',st).textContent=purchaseQty+' '+(purchaseQty===1?'bag':'bags')+' · '+(p.nights*purchaseQty)+' nights';
    var old=$('.sticky-price s',st);if(old)old.innerHTML=p.compareAt>p.price?'<span class="sr-only">Was </span>'+money(p.compareAt*purchaseQty):'';
    $('.btn',st).setAttribute('aria-label','Add '+purchaseQty+' '+(purchaseQty===1?'bag':'bags')+' of Night Dream to cart — '+money(p.price*purchaseQty));
  }
  syncPurchaseControls();
}
function steps(){ return [PACKS[1].price, PACKS[2].price - PACKS[1].price, PACKS[3].price - PACKS[2].price]; }
function stepsValid(){ var s = steps(); return s[0] > s[1] && s[1] > s[2]; }            // the line below is only true when every extra bag costs less
function bestPerNight(){
  var best = 0, n = 1;
  for(var i = 1; i <= 3; i++){ var v = PACKS[i].price / PACKS[i].nights; if(!best || v < best - 1e-9){ best = v; n = i; } }
  return n;
}
function stepsText(){ var s = steps(); return 'Each extra bag costs less: '+money(s[0])+' → '+money(s[1])+' → '+money(s[2])+'.'; }
function freeNote(n){ return (FREE_OVER > 0 && PACKS[n].price >= FREE_OVER) ? ' — free delivery' : ''; }
function renderPickline(){
  if(!pickline || !PACKS[1] || !PACKS[2] || !PACKS[3]) return;
  if(sel === 1){
    pickline.innerHTML = '<button type="button" class="nudge" data-pick="2">Add 1 more bag for '+money(PACKS[2].price - PACKS[1].price)+freeNote(2)+'</button>';
  } else if(sel === 2){
    pickline.innerHTML = avatarImg(30)+'<span><b>Luna’s pick: 2 bags.</b>'+(stepsValid() ? ' '+stepsText() : '')+'</span>';
  } else {
    pickline.innerHTML = bestPerNight() === 3 ? avatarImg(30)+'<span><b>Best price per night.</b>'+(stepsValid() ? ' '+stepsText() : '')+'</span>' : '';
  }
}
function setSel(n){
  if(singleBagOnly) n = 1;
  if(!PACKS[n]) return;
  sel = n;
  var p = PACKS[n];
  $$('#opts .opt').forEach(function(o){
    var on = +o.getAttribute('data-n') === n;
    o.classList.toggle('on', on);
    o.setAttribute('aria-checked', on ? 'true' : 'false');
    o.tabIndex = on ? 0 : -1;
  });
  var pr = opts ? ($('#pick') || $('.buy .pr')) : null;   if(pr) pr.innerHTML = (p.compareAt > p.price ? '<s><span class="sr-only">Was </span>'+money(p.compareAt)+'</s> ' : '')+'<strong>'+(p.compareAt > p.price ? '<span class="sr-only">Now </span>' : '')+money(p.price)+'</strong>'+(p.compareAt > p.price ? ' <span class="sale-badge">'+Math.round((p.compareAt-p.price)/p.compareAt*100)+'% OFF</span>' : '');   // Shared home/product pack selection
  var go = $('#buy .go') || $('#shop .go');   if(go) go.textContent = 'Add '+p.label+' — '+money(p.price);
  var st = $('#sticky');
  if(st){
    var old=$('.sticky-price s',st), badge=$('.sticky-discount',st), sale=p.compareAt>p.price;
    $('.sticky-current',st).innerHTML=(sale?'<span class="sr-only">Now </span>':'')+money(p.price);
    $('.sticky-pack',st).textContent=p.label+' · '+p.nights+' nights';
    old.hidden=!sale; old.innerHTML=sale?'<span class="sr-only">Was </span>'+money(p.compareAt):'';
    badge.hidden=!sale; badge.textContent=sale?Math.round((p.compareAt-p.price)/p.compareAt*100)+'% OFF':'';
    $('.btn',st).setAttribute('aria-label','Add '+p.label+' of Night Dream to cart — '+money(p.price));
  }
  renderPickline();
  if(purchaseInput) setPurchaseQty(purchaseQty);
}
var opts = $('#opts');
if(opts){
  opts.addEventListener('keydown', function(e){
    var k = e.key, n = sel, hit = false;
    if(k === 'ArrowRight' || k === 'ArrowDown'){ n = Math.min(3, sel+1); hit = true; }
    else if(k === 'ArrowLeft' || k === 'ArrowUp'){ n = Math.max(1, sel-1); hit = true; }
    else if(k === ' ' || k === 'Enter'){ var o = e.target.closest ? e.target.closest('.opt') : null; if(o){ n = +o.getAttribute('data-n'); hit = true; } }
    if(!hit) return;
    e.preventDefault();
    setSel(n);
    var f = $('#opts .opt[data-n="'+n+'"]'); if(f) f.focus();
  });
}

/* Where "choose your bag" buttons land. On the product page: the price row on phones (so the price, the three bags
   and Add all fit on one screen) and the top of the buy box on wide screens. On any other page (home, policies):
   the product page, with the same bag choice and the same landing spot. */
function toPick(){
  closeCart(true);
  var t = phone.matches ? ($('#pick') || $('#buy')) : $('#buy');
  if(!t){ goTo((LO.productUrl || '/products/night-dream-chewable-tablet-peach') + (sel !== 2 ? '?bag=' + sel : '') + (phone.matches ? '#pick' : '#buy')); return; }
  t.scrollIntoView({block:'start'});
}
var pendingNav = null;
function goTo(url){                      // let the cart's history step finish first, so no stray entry is left behind
  if(undoing){ pendingNav = url; setTimeout(flushNav, 700); } else location.href = url;
}
function flushNav(){ if(pendingNav){ var u = pendingNav; pendingNav = null; location.href = u; } }

/* ---- Cart: Shopify's real cart ---- */
var cart = {items:[], item_count:0, total_price:0};
var cartBusy = false, cartUncertain = false, cartVersion = 0, cartLoadSeq = 0;
var cartPage = $('[data-cart-page]'), cartLoaded = false;      // /cart shows the same lines as the drawer, so it shares the renderer
function api(url, body){
  var opt = {credentials:'same-origin', cache:'no-store', headers:{'Accept':'application/json'}};
  if(body){ opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
  return fetch(url, opt).then(function(r){
    return r.json().catch(function(){ return {}; }).then(function(j){ if(!r.ok) throw j; return j; });
  });
}
function loadCart(){
  var version = cartVersion, request = ++cartLoadSeq;
  return api(ROUTES.cartJs).then(function(c){
    if(version !== cartVersion || request !== cartLoadSeq) return c;
    cart = c; cartLoaded = true; cartUncertain = false; renderCart(); return c;
  });
}
function syncCartBusy(){
  $$('[data-add], [data-qty], [data-rm], [data-swap], [data-checkout]').forEach(function(el){
    el.disabled = cartBusy || (el.hasAttribute('data-checkout') && (!cartLoaded || cartUncertain));
  });
  $$('[data-cart-page], .cart').forEach(function(el){ el.setAttribute('aria-busy', cartBusy ? 'true' : 'false'); });
  syncPurchaseControls();
}
function runCartMutation(work){
  if(cartBusy) return Promise.resolve(false);
  cartBusy = true; cartVersion++; notice = ''; syncCartBusy();
  return Promise.resolve().then(work).catch(function(e){
    notice = (e && (e.description || e.message)) || 'Sorry, we could not update your cart. Please try again.';
    return loadCart().then(function(){ return false; }, function(){
      cartUncertain = true; notice = 'We could not confirm your cart. Refresh it before checking out.'; renderCart(); return false;
    });
  }).then(function(result){ cartBusy = false; renderCart(); syncCartBusy(); return result; });
}
function packIdOf(variantId){ for(var k in PACKS){ if(PACKS[k].id && PACKS[k].id === variantId) return +k; } return 0; }
function cartLines(){
  return (cart.items || []).map(function(it){ var id = packIdOf(it.variant_id); return {id:id, qty:it.quantity, pack:PACKS[id], key:it.key, item:it}; });
}
function cartTotals(){
  var t = {sub:cart.total_price || 0, bags:0, count:cart.item_count || 0};
  cartLines().forEach(function(l){ if(l.pack) t.bags += l.pack.bags*l.qty; });
  t.nights = t.bags * 20;
  return t;
}
function findLine(key){ var ls = cartLines(); for(var i = 0; i < ls.length; i++) if(ls[i].key === key) return ls[i]; return null; }
function buildCart(){
  if(cartEl) return;
  cartEl = document.createElement('div');
  cartEl.className = 'cart-ov'; cartEl.id = 'cart'; cartEl.hidden = true;
  cartEl.innerHTML =
    '<aside class="cart" role="dialog" aria-modal="true" aria-labelledby="cart-t" tabindex="-1">'+
      '<div class="cart-h"><h3 id="cart-t">Your cart (<span data-cart-count>0</span>)</h3>'+
        '<button type="button" class="cart-x" aria-label="Close cart" data-cart-close>&times;</button></div>'+
      '<div class="cart-body" data-cart-body></div>'+
      '<div class="cart-f" data-cart-foot></div>'+
    '</aside>';
  document.body.appendChild(cartEl);
  cartEl.addEventListener('click', function(e){ if(e.target === cartEl) closeCart(); });
}
function renderCart(){
  var t = cartTotals();
  if(cartLoaded) $$('[data-cart-count]').forEach(function(el){ el.textContent = t.count; });   // until then the number Shopify printed in the page stays
  var bodies = $$('[data-cart-body]');                        // the drawer (once it is built) and the /cart page
  if(!bodies.length) return;
  var v = cartView(t);
  bodies.forEach(function(body){
    if(!cartLoaded && body.closest('[data-cart-page]')) return;   // the page keeps its "loading" line until Shopify has answered
    var foot = $('[data-cart-foot]', body.parentNode);
    body.innerHTML = v.body;
    if(foot){ foot.innerHTML = v.foot; foot.hidden = !v.foot; }
  });
  syncCartBusy();
}
function cartView(t){
  var ls = cartLines();
  var note = notice ? '<p class="cart-demo" role="alert">'+esc(notice)+'</p>' : '';
  if(cartUncertain) note += '<button type="button" class="btn" data-cart-refresh>Refresh cart</button>';
  if(!ls.length) return {body:'<div class="cart-empty"><p>Your cart is empty.</p><button type="button" class="btn" data-to-pick>Choose your bag</button>'+note+'</div>', foot:''};
  var h = '';
  if(FREE_OVER > 0){
    var unlocked = t.sub >= FREE_OVER;
    var pct = unlocked ? 100 : Math.round(t.sub / FREE_OVER * 100);
    h += '<div class="cart-free" role="status"><p>'+(unlocked ? 'You’ve unlocked <b>free delivery</b>.' : 'Add <b>'+money(FREE_OVER - t.sub)+'</b> more to unlock <b>free delivery</b>.')+'</p><div class="cf-bar"><i style="width:'+pct+'%"></i></div></div>';
  }
  if(t.nights) h += '<span class="cart-nights">'+t.nights+' nights ready</span>';
  h += '<ul class="cart-lines">';
  ls.forEach(function(l){
    var it = l.item, p = l.pack;
    var img = it.image || THUMB;
    var title = p ? 'Night Dream — '+p.label : (it.product_title || it.title || 'Item');
    var meta = p ? p.nights+' nights · '+perNight(p) : (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '');
    h += '<li class="cart-line" data-key="'+esc(l.key)+'">'+
      (img ? '<img src="'+esc(img)+'" alt="" width="72" height="72">' : '<span style="display:block;width:72px;height:72px;border-radius:12px;background:#EDE7F6"></span>')+
      '<div class="cl-info"><b>'+esc(title)+'</b><span>'+esc(meta)+'</span>'+
        '<div class="cl-qty"><button type="button" aria-label="One less" data-qty="-1">−</button><span aria-live="polite">'+l.qty+'</span><button type="button" aria-label="One more" data-qty="1">+</button></div></div>'+
      '<div class="cl-price"><b>'+money(it.final_line_price != null ? it.final_line_price : it.line_price)+'</b><button type="button" class="cl-rm" data-rm>Remove</button></div></li>';
  });
  h += '</ul>';
  if(!singleBagOnly && !LO.saleActive && ls.length === 1 && ls[0].id === 1 && ls[0].qty === 1 && PACKS[2] && PACKS[2].id){
    h += '<button type="button" class="cart-up" data-swap>+ Add 1 more bag for '+money(PACKS[2].price - PACKS[1].price)+freeNote(2)+'</button>';
  }
  return {body:h, foot:
    '<div class="cart-sub"><span>Subtotal</span><b>'+money(t.sub)+'</b></div>'+
    '<p class="cart-note">Delivery and your discount code are added at checkout.</p>'+
    (LO.saleActive ? '<p class="cart-note">WELCOME10 cannot be combined with promotional prices. Save your unused code for a future full-price order after the promotion ends.</p>' : '')+
    '<button type="button" class="btn" data-checkout>Checkout — '+money(t.sub)+'</button>'+
    note+
    '<div class="cart-sloth">'+avatarImg(34)+'<span>Sweet dreams. See you tomorrow.</span></div>'};
}
function openCart(opener){
  buildCart(); renderCart();
  cartOpener = opener || document.activeElement;
  cartEl.hidden = false; lock(true);
  pushCartEntry();
  $('.cart', cartEl).focus({preventScroll:true});
  updSticky();
  var items = cartItems(); if(items.length) track('view_cart', trackEcom(items));
}
function closeCart(silent){
  if(!cartEl || cartEl.hidden) return;
  cartEl.hidden = true; lock(false);
  dropCartEntry();
  if(!silent && cartOpener && cartOpener.focus) cartOpener.focus({preventScroll:true});
  updSticky();
}
function bump(){ $$('.cart-btn').forEach(function(b){ b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }); }
function setNotice(msg){ notice = msg || ''; renderCart(); }
function addToCart(id, from, quantity){
  quantity = Math.max(1,Math.min(9,parseInt(quantity,10)||1));
  var p = PACKS[id];
  if(!p || !p.id){ setNotice('Night Dream is not on sale in this store yet.'); return Promise.resolve(false); }
  var had = 0; cartLines().forEach(function(l){ if(l.id === id) had += l.qty; });
  if(had + quantity > 9){ setNotice('You can add up to 9 of each bag.'); return Promise.resolve(false); }
  return runCartMutation(function(){
    return api(ROUTES.cartAdd, {items:[{id:p.id, quantity:quantity}]}).then(function(){
      track('add_to_cart', trackEcom([trackItem(id, quantity)]), {source:from || 'other'}); bump();
      return loadCart().then(function(){ return true; });
    });
  });
}
function changeLine(key, qty){
  return runCartMutation(function(){
    return api(ROUTES.cartChange, {id:key, quantity:qty}).then(function(c){ cart = c; cartLoaded = true; renderCart(); return c; });
  });
}

/* ---- Back button closes the cart ----
   Opening the cart adds one history entry, so Back (Android button, iPhone edge swipe, browser button) closes the cart
   instead of leaving the page. Closing it any other way (×, Esc, tap outside) takes that entry off again. */
var prevRestore = null;                               // the browser's own scroll handling, put back after each step
function pushCartEntry(){
  if(cartEntry || !window.history || !history.pushState) return;
  try{
    // while the cart is open the browser must not jump the page back to where it was when we step back
    if('scrollRestoration' in history){ prevRestore = history.scrollRestoration; history.scrollRestoration = 'manual'; }
    history.pushState({loCart:1}, ''); cartEntry = true;
  }catch(e){}
}
function afterStep(){
  if(prevRestore === null) return;
  try{ history.scrollRestoration = prevRestore; }catch(e){}
  prevRestore = null;
}
function dropCartEntry(){
  if(!cartEntry) return;
  cartEntry = false; undoing = true;                  // the popstate this causes is ours: ignore it
  try{ history.back(); }catch(e){ undoing = false; afterStep(); }
}
window.addEventListener('popstate', function(){
  if(undoing){ undoing = false; afterStep(); flushNav(); return; }
  if(cartEntry){ cartEntry = false; afterStep(); closeCart(); }    // Back was pressed with the cart open
});
window.addEventListener('pageshow', function(e){ if(e.persisted) loadCart().catch(function(){}); });

/* ---- One click handler for every button on the page ---- */
document.addEventListener('click', function(e){
  var t = e.target; if(!t.closest) return;
  var el;
  if((el=t.closest('[data-quantity-step]'))){e.preventDefault();setPurchaseQty(purchaseQty + +el.getAttribute('data-quantity-step'));return;}
  if((el = t.closest('#opts .opt'))){ setSel(+el.getAttribute('data-n')); return; }
  if((el = t.closest('[data-pick]'))){
    e.preventDefault(); setSel(+el.getAttribute('data-pick'));
    if(el.hasAttribute('data-to-pick')) toPick();
    return;
  }
  if((el = t.closest('[data-to-pick]'))){ e.preventDefault(); toPick(); return; }
  if((el = t.closest('[data-add]'))){
    e.preventDefault();
    var v = el.getAttribute('data-add');
    var pid = v === 'sel' ? sel : +v, from = trackFrom(el);
    openCart(el);
    if(v === 'sel' && purchaseInput) setPurchaseQty(purchaseInput.value);
    addToCart(pid, from, v === 'sel' && purchaseInput ? purchaseQty : 1);
    return;
  }
  if((el = t.closest('[data-cart-open]'))){
    e.preventDefault();
    if(cartPage){ cartPage.scrollIntoView({block:'start'}); loadCart().catch(function(){}); return; }   // already on the cart page: no second cart on top of it
    openCart(el); loadCart().catch(function(){}); return;
  }
  if(t.closest('[data-cart-close]')){ closeCart(); return; }
  if((el = t.closest('[data-qty]'))){
    e.preventDefault(); if(cartBusy) return;
    var ln = findLine(el.closest('.cart-line').getAttribute('data-key')); if(!ln) return;
    var step = +el.getAttribute('data-qty'), was = ln.qty, now = Math.max(0, Math.min(9, was + step));
    if(now === was) return;
    changeLine(ln.key, now).then(function(changed){ if(changed && ln.id) track(step > 0 ? 'add_to_cart' : 'remove_from_cart', trackEcom([trackItem(ln.id, 1)]), {source:'cart'}); });
    return;
  }
  if((el = t.closest('[data-rm]'))){
    e.preventDefault(); if(cartBusy) return;
    var rl = findLine(el.closest('.cart-line').getAttribute('data-key')); if(!rl) return;
    changeLine(rl.key, 0).then(function(changed){ if(changed && rl.id) track('remove_from_cart', trackEcom([trackItem(rl.id, rl.qty)]), {source:'cart'}); });
    return;
  }
  if(t.closest('[data-swap]')){
    if(cartBusy || singleBagOnly) return;
    var one = null; cartLines().forEach(function(l){ if(l.id === 1) one = l; });
    if(!one || !PACKS[2] || !PACKS[2].id) return;
    runCartMutation(function(){ return api(ROUTES.cartChange, {id:one.key, quantity:0})
      .then(function(){ return api(ROUTES.cartAdd, {items:[{id:PACKS[2].id, quantity:1}]}); })
      .then(function(){
        track('remove_from_cart', trackEcom([trackItem(1, one.qty)]), {source:'cart'});
        track('add_to_cart', trackEcom([trackItem(2, 1)]), {source:'cart'});
        return loadCart();
      })
      ; });
    return;
  }
  if(t.closest('[data-cart-refresh]')){
    if(cartBusy) return;
    runCartMutation(function(){ return loadCart(); }); return;
  }
  if(t.closest('[data-checkout]')){
    e.preventDefault(); if(cartBusy || cartUncertain || !cartLoaded) return;
    track('begin_checkout', trackEcom(cartItems()), {source:'cart'});
    window.location.href = ROUTES.checkout;
    return;
  }
});
document.addEventListener('change', function(e){if(e.target===purchaseInput)setPurchaseQty(purchaseInput.value);});
document.addEventListener('keydown', function(e){
  if(!cartEl || cartEl.hidden) return;
  if(e.key === 'Escape'){ closeCart(); return; }
  if(e.key !== 'Tab') return;
  var f = $$('button,a[href],input', cartEl).filter(function(x){ return x.offsetParent !== null && !x.disabled; });
  if(!f.length) return;
  var first = f[0], last = f[f.length-1], a = document.activeElement, dlg = $('.cart', cartEl);
  if(e.shiftKey && (a === first || a === dlg)){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && a === last){ e.preventDefault(); first.focus(); }
});

/* ---- Sticky buy bar ----
   Shows once the hero button has scrolled away, and hides while a real buy button is on screen
   (buy box, mid-page buy, final buy) or the footer is reached, so there is never a double button. */
var sticky = $('#sticky');
function inView(el){
  if(!el) return false;
  var r = el.getBoundingClientRect();
  return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
}
function updSticky(){
  if(!sticky) return;
  var go = $('#buy .go') || $('#shop-btns'); if(!go) return;      // product page: the Add button; home page: the product card's buttons
  var hero = $('.hero-full .btn');
  var passed = hero ? hero.getBoundingClientRect().bottom < 0 : go.getBoundingClientRect().bottom < 0;
  var buyOnScreen = inView(go) || inView($('.creator-cta .btn')) || inView($('#midbuy .midbuy-btns')) || inView($('.final-buy .btn'));
  var ft = $('footer'), atFooter = ft && ft.getBoundingClientRect().top < (window.innerHeight || 0) - 60;
  var busy = (cartEl && !cartEl.hidden) || (popEl && !popEl.hidden);
  sticky.classList.toggle('show', !!(passed && !buyOnScreen && !atFooter && !busy));
}
var tick = false;
function onScrollResize(){ if(tick) return; tick = true; (window.requestAnimationFrame || setTimeout)(function(){ tick = false; updSticky(); }); }
window.addEventListener('scroll', onScrollResize, {passive:true});
window.addEventListener('resize', onScrollResize);

/* ---- Announcement bar: two lines rotate on phones ---- */
(function(){
  var a = $$('#announce .a');
  if(a.length < 2 || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  var i = 0;
  setInterval(function(){ a[i].classList.remove('on'); i = (i+1) % a.length; a[i].classList.add('on'); }, 4500);
})();

/* ---- Mobile menu ---- */
var menuBtn = $('.menu-btn'), menu = $('#m-menu');
if(menuBtn && menu){
  menuBtn.addEventListener('click', function(){
    var open = menu.hidden;
    menu.hidden = !open;
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  menu.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('a')){ menu.hidden = true; menuBtn.setAttribute('aria-expanded', 'false'); }
  });
  function closeMenu(restoreFocus){
    if(menu.hidden) return;
    menu.hidden = true; menuBtn.setAttribute('aria-expanded', 'false');
    if(restoreFocus) menuBtn.focus();
  }
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !menu.hidden){ e.preventDefault(); closeMenu(true); }
  });
  document.addEventListener('click', function(e){
    if(!menu.contains(e.target) && !menuBtn.contains(e.target)) closeMenu(false);
  });
}

/* ---- Gallery ----
   Wide screens: the thumbnails swap the big picture.
   Phones: the big picture is hidden and the row is only a swipe strip of photos, so the thumbnails stop being buttons
   there (no tab stops, no taps that do nothing). A screen reader still meets them as labelled pictures. */
var gmain = $('#gmain'), thumbs = $$('#gthumbs button');
function thumbMode(){
  thumbs.forEach(function(b){
    if(phone.matches){ b.setAttribute('role', 'img'); b.tabIndex = -1; }
    else { b.removeAttribute('role'); b.removeAttribute('tabindex'); }
  });
}
if(gmain && thumbs.length){
  thumbs.forEach(function(b){
    b.addEventListener('click', function(){
      if(phone.matches) return;
      gmain.src = b.getAttribute('data-src');
      gmain.alt = b.getAttribute('aria-label') || gmain.alt;
      thumbs.forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
    });
  });
  thumbMode();
  if(phone.addEventListener) phone.addEventListener('change', thumbMode);
  else if(phone.addListener) phone.addListener(thumbMode);
}

/* ---- Email sign-up (footer and pop-up) ----
   The forms are Shopify customer forms. A submit is sent in the background and the thank-you message replaces the
   form; if that fails the form is sent the normal way. "Seen" is kept for this visit only (sessionStorage). */
var SEEN = 'lo-pop';
function seen(){ try{ return !!sessionStorage.getItem(SEEN); }catch(e){ return false; } }
function markSeen(){ try{ sessionStorage.setItem(SEEN, '1'); }catch(e){} }
function signupDone(box){
  box.classList.add('is-done');
  var d = box.querySelector('.done-msg'); if(d) d.focus();
  markSeen();   // someone who has signed up is not asked again
}
$$('[data-signup-box] form').forEach(function(f){
  f.addEventListener('submit', function(e){
    if(!window.fetch || !window.FormData) return;           // old browser: the normal form post
    e.preventDefault();
    if(f.getAttribute('aria-busy') === 'true') return;
    var box = f.closest('[data-signup-box]'), submit = f.querySelector('[type="submit"]');
    var body = new FormData(f);
    f.setAttribute('aria-busy', 'true');
    if(submit) submit.disabled = true;
    function reset(){ f.removeAttribute('aria-busy'); if(submit) submit.disabled = false; }
    function normalSubmit(){ reset(); HTMLFormElement.prototype.submit.call(f); }
    fetch(f.action, {method:'POST', body:body, credentials:'same-origin', headers:{'Accept':'text/html'}})
      .then(function(r){
        if(!r.ok) throw new Error('Signup response failed');
        return r.text().then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if(doc.querySelector('[data-signup-ok]')){ reset(); signupDone(box); }
          else normalSubmit();
        });
      })
      .catch(normalSubmit);
  });
});
$$('[data-signup-ok]').forEach(function(el){ var box = el.closest('[data-signup-box]'); if(box) signupDone(box); });   // a normal post came back with success

/* ---- First-order pop-up ----
   Opens once per visit, and only at a calm moment: after the visitor has scrolled past the mid-page buy section,
   or when the mouse heads for the browser bar (wide screens), or as a last resort after 90 seconds.
   It never opens while someone is typing, while the cart is open, or while the bag cards or the Add button are on screen.
   On phones it is a short sheet at the bottom, so the first screen stays visible.
   Add ?popup to the address to see it straight away. */
(function(){
  var pop = popEl;
  if(!pop) return;
  var force = /[?&]popup\b/.test(location.search), back = null, shown = false, t0 = Date.now();
  if(!force && seen()) return;
  var img = $('img[data-src]', pop);
  function load(){   // the photo is only used on wide screens, so phones never download it
    var src = img && img.getAttribute('data-src');
    if(src && window.matchMedia('(min-width:961px)').matches){ img.src = src; img.removeAttribute('data-src'); }
  }
  function busy(){
    var a = document.activeElement;
    if(a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    if(cartEl && !cartEl.hidden) return true;
    if(inView($('#opts')) || inView($('#buy .go')) || inView($('#shop-btns'))) return true;           // choosing a bag
    return false;
  }
  function open(){
    if(shown || (!force && seen())) return;
    if(!force && busy()) return;           // try again at the next trigger
    shown = true; load(); back = document.activeElement;
    pop.hidden = false; lock(true);
    $('.pop', pop).focus({preventScroll:true});
    updSticky();
  }
  function close(){
    pop.hidden = true; lock(false); markSeen();
    if(back && back.focus) back.focus();
    updSticky();
  }
  var mid = $('#midbuy') || $('.about-brand');   // the home page has no mid-page buy block: use the end of the About section
  window.addEventListener('scroll', function(){
    if(mid && Date.now() - t0 > 8000 && mid.getBoundingClientRect().bottom < 0) open();
  }, {passive:true});
  document.addEventListener('mouseout', function(e){
    if(!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 15000) open();
  });
  (function wait(){
    if(shown) return;
    if(Date.now() - t0 >= 90000) open();
    if(!shown) setTimeout(wait, 5000);
  })();
  setTimeout(load, force ? 0 : 40000);
  if(force) setTimeout(open, 800);
  pop.addEventListener('click', function(e){
    if(e.target === pop || e.target.closest('[data-pop-close]')){ e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function(e){
    if(pop.hidden) return;
    if(e.key === 'Escape'){ close(); return; }
    if(e.key !== 'Tab') return;
    var f = [].filter.call(pop.querySelectorAll('a[href],button,input'), function(x){ return x.offsetParent !== null; });
    var first = f[0], last = f[f.length-1], now = document.activeElement;
    if(e.shiftKey && (now === first || now === $('.pop', pop))){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && now === last){ e.preventDefault(); first.focus(); }
  });
})();

/* ---- Start ---- */
applyFree();
if((opts || singleBagOnly) && PACKS[1] && PACKS[2] && PACKS[3]){
  var bag = /[?&]bag=([123])(?![0-9])/.exec(location.search);   // the home page's "Try 20 nights" button arrives with ?bag=1
  if(bag) sel = +bag[1];
  setSel(sel);
}
renderCart();
loadCart().then(function(){
  if(!cartPage) return;
  var items = cartItems(); if(items.length) track('view_cart', trackEcom(items));
}).catch(function(){
  var b = cartPage && $('[data-cart-body]', cartPage);
  if(b) b.innerHTML = '<p class="cart-loading" role="alert">Sorry, we could not load your cart. Please refresh the page.</p>';
});
updSticky();

})();
